import HelpSupportContainer from "./HelpSupportContainer";
import HelpSupportStore from "./HelpSupportStore";


export default HelpSupportStore(HelpSupportContainer);